export const isHexColor = (color) => {
    const hexColorRegex = /^#[0-9a-fA-F]{6}$/;
    return hexColorRegex.test(color);
};
